<template>
  <div  id="function" :class="classdate">
    <div>
      <h3>以标化健康数据为支撑，专注提供会员健康数字化解决方案</h3>
      <div class="date-conter clear">
        <el-col :xs="8" :sm="6" :md="6" :lg="7" :xl="7">
          <ul class="datelist">
            <li v-for="(img,i) in datelist" :key="i" @mouseover="handlehover('移入',i)" @mouseleave="handlehover('移除',i)">
              <img :src="img.src">{{img.content}}
            </li>
          </ul>
        </el-col>
        <el-col :xs="16" :sm="18" :md="18" :lg="17" :xl="17" class="dateimg">
          <img :src="dateimg" class="ioc">
          <p>{{dateimgCont}}</p>
        </el-col>
      </div>
      <div class="Mobile">
        <div v-for="(img,i) in datelist" :key="i" class="Split">
          <span><img :src="img.src">{{img.content}}</span>
          <div class="img">
            <img :src="img.dateimg">
            <h2 style="padding: 0 30px; font-size: 14px;font-weight: 400">{{img.content2}}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "functions",
        props:['classdate'],
        data(){
            return{
                datelist:[{
                    src:require('../../static/assets/deploymentunit.png'),
                    content:'多项指标移动快检',
                    dateimg:require('../../static/assets/tupian1.png'),
                    content2:'配合天下医生全国独家的四合一智能数字终端，可实现“一机”移动快速检测：血糖、血酮、尿酸和总胆固醇'
                },{
                    src:require('../../static/assets/crown.png'),
                    content:'会员易锁定高忠诚',
                    dateimg:require('../../static/assets/tu2@1x.png'),
                    content2:'天下医生合作伙伴使用会员管家后所产生的数据，可完全归属合作伙伴独立管理（如：为合作伙伴建独立数据库、配置华为专属云、配置可设置独立登录账号和密码的后台数据管理系统平台等）'
                },{
                    src:require('../../static/assets/linechart.png'),
                    content:'适销人群数倍增加',
                    dateimg:require('../../static/assets/tu3@1x.png'),
                    content2:'“监测疾病、预防筛查”，几乎可全部覆盖“到店顾客和全部会员”，更可轻松扩展至家庭。以多项指标检测为起点，无论是老病人指标监测，还是个人及家庭成员健康自我预防筛查，均可适用。'
                },{
                    src:require('../../static/assets//aim.png'),
                    content:'会员需求精准触达',
                    dateimg:require('../../static/assets/tu4@1x.png'),
                    content2:'以标准化的医疗健康检测数据为支撑，以同步配置的免费医生解读服务、免费医生在线电话或视频咨询服务、免费到店打印纸质报告服务等为协同，可系统性帮助机构识别自己会员真实有用的需求，有利于更为精准的向会员提供所需的、适合的“产品和服务”。'
                },{
                    src:require('../../static/assets/piechart.png'),
                    content:'产生数据机构拥有',
                    dateimg:require('../../static/assets/tu5@1x.png'),
                    content2:'天下医生合作伙伴使用会员管家后所产生的数据，可完全归属合作伙伴独立管理（如：为合作伙伴建独立数据库、配置华为专属云、配置可设置独立登录账号和密码的后台数据管理系统平台等）'
                }],
                dateimg:require('../../static/assets/tupian1.png'),
                dateimgCont:'配合天下医生全国独家的四合一智能数字终端，可实现“一机”移动快速检测：血糖、血酮、尿酸和总胆固醇',
                imgchange:[{
                    hover:require('../../static/assets/deploymentunit2.png'),
                    lever:require('../../static/assets/deploymentunit.png'),
                    dateimg:require('../../static/assets/tupian1.png'),
                    content:'配合天下医生全国独家的四合一智能数字终端，可实现“一机”移动快速检测：血糖、血酮、尿酸和总胆固醇'
                },{
                    hover: require('../../static/assets/crown2.png'),
                    lever: require('../../static/assets/crown.png'),
                    dateimg:require('../../static/assets/tu2@1x.png'),
                    content:'天下医生合作伙伴使用会员管家后所产生的数据，可完全归属合作伙伴独立管理（如：为合作伙伴建独立数据库、配置华为专属云、配置可设置独立登录账号和密码的后台数据管理系统平台等）'
                },{
                    hover:require('../../static/assets/linechart2.png') ,
                    lever:require('../../static/assets/linechart.png'),
                    dateimg:require('../../static/assets/tu3@1x.png'),
                    content:'“监测疾病、预防筛查”，几乎可全部覆盖“到店顾客和全部会员”，更可轻松扩展至家庭。以多项指标检测为起点，无论是老病人指标监测，还是个人及家庭成员健康自我预防筛查，均可适用。'
                },{
                    hover:require('../../static/assets/aim2.png') ,
                    lever:require('../../static/assets/aim.png'),
                    dateimg:require('../../static/assets/tu4@1x.png'),
                    content:'以标准化的医疗健康检测数据为支撑，以同步配置的免费医生解读服务、免费医生在线电话或视频咨询服务、免费到店打印纸质报告服务等为协同，可系统性帮助机构识别自己会员真实有用的需求，有利于更为精准的向会员提供所需的、适合的“产品和服务”。'
                },{
                    hover:require('../../static/assets/piechart2.png') ,
                    lever:require('../../static/assets/piechart.png'),
                    dateimg:require('../../static/assets/tu5@1x.png'),
                    content:'天下医生合作伙伴使用会员管家后所产生的数据，可完全归属合作伙伴独立管理（如：为合作伙伴建独立数据库、配置华为专属云、配置可设置独立登录账号和密码的后台数据管理系统平台等）'
                }],
            }
        },
        methods:{
            handlehover(item,value){
                if(item=='移入'){
                    this.datelist[value].src=this.imgchange[value].hover;
                    this.dateimg=this.imgchange[value].dateimg;
                    this.dateimgCont=this.imgchange[value].content;
                }else {
                    this.datelist[value].src=this.imgchange[value].lever;
                }
            },
        }
    }
</script>

<style lang="less">
.clear:after{
  content: ' ';
  clear: both;
  display:block;
  height:0;
  visibility:hidden;
}
@media only screen and (max-width: 1920px){
  #function::after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 190px;
    width: 100%;
    margin: 0 auto;
    z-index: -1;
    background: url("../../static/assets/diwen@1x.png") center;
  }
  .margintop{
    padding-top: 80px;
  }
  #function{
    position: relative;
    h3{
      font-size: 36px;
      line-height: 150px;
      font-weight:500;
    }
    .date-conter{
      display: block;
      margin: 0 auto;
      display: inline-block;
      margin-bottom: 190px;
      .datelist{
        padding: 20px 0;
        li{
          width: 280px;
          line-height: 90px;
          font-size: 20px;
          border-radius: 5px;
          img{
            width: 40px;
            height: 40px;
            margin-right: 10px;
            vertical-align: middle;
          }
        }
        li:hover{
          color: #fff;
          background:linear-gradient(90deg,rgba(83,187,168,1) 0%,rgba(0,161,188,1) 58%,rgba(0,128,201,1) 100%) ;
        }
      }
      .dateimg{
        img{
          width: 800px;
          height: 450px;
        }
        p{
          width: 800px;
          height: 75px;
          margin: 0 auto;
          color: #333333;
          font-size: 17px;
          font-weight:400;
          line-height:25px;
        }
      }
    }
    .Mobile{
      display: none;
    }
  }
}
@media only screen and (max-width: 1370px){
  .margintop{
    padding-top: 60px;
  }
  #function{
    h3{
      font-size: 30px;
      line-height: 110px;
    }
    .date-conter{
      display: block;
      margin-bottom: 190px;
      .datelist{
        li{
          width: 200px;
          line-height: 80px;
          font-size: 17px;
          img{
            width: 35px;
            height: 35px;
          }
        }
      }
      .dateimg{
        img{
          width: 700px;
          height: 400px;
        }
        p{
          width: 700px;
          height: 75px;
          font-size: 16px;
          line-height:25px;
        }
      }
    }
    .Mobile{
      display: none;
    }
  }
}
@media only screen and (max-width: 992px){
  #function::after{
    height: 150px;
  }
   #function{
    h3{
      font-size: 25px;
      line-height: 110px;
    }
    .date-conter{
      display: block;
      margin-bottom: 88px;
      .datelist{
        li{
          width: 180px;
          line-height: 80px;
          font-size: 15px;
          img{
            width: 27px;
            height: 25px;
          }
        }
      }
      .dateimg{
        img{
          width: 550px;
          height: 320px;
        }
        p{
          width: 550px;
          height: 190px;
          font-size: 14px;
          line-height:25px;
        }
      }
    }
     .Mobile{
       display: none;
     }
  }
}
@media only screen and (max-width: 768px){
  #function::after{
    display: none;
  }
   #function{
    h3{
      font-size: 13px;
      line-height: 80px;
    }
    .date-conter{
      display: none;
      margin-bottom: 50px;
      .datelist{
        li{
          width: 100%;
          line-height: 60px;
          font-size: 12px;
          img{
            width: 20px;
            height: 18px;
            margin-right: 5px;
          }
        }
      }
      .dateimg{
        img{
          width: 250px;
          height: 190px;
          margin-left: 10px;
        }
        p{
          width: 250px;
          font-size: 12px;
          line-height:25px;
        }
      }
    }
     .Mobile {
       display: block;
       .Split{
         display: block;
         margin-bottom: 55px;
         span{
           font-size: 18px;
           font-weight: 600;
           display: block;
           text-align: center;
           img{
             width: 30px;
             height: 30px;
             vertical-align: middle;
             margin-right: 10px;
           }
         }
         .img{
           margin-bottom: 0 !important;
           img{
             width: 70%;
             display: block;
             text-align: center;
             margin:0 auto;
           }
           h2{
             color: #333;
             font-size: 15px;
             /*margin-bottom: 25px;*/
             text-align: center;
           }
         }
       }
     }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/functions.vue